import React, {
    useState,
    useEffect,
    createContext,
    useContext,
} from "react";

export const PaymentContext = createContext(undefined);

export const usePaymentContext = () => {
    const context = useContext(PaymentContext);
    if (!context) {
        throw new Error("usePaymentContext must be used within a PaymentContextProvider");
    }
    return context;
};

const PaymentContextProvider = ({ children }) => {
    const tpPercent = parseInt(process.env.REACT_APP_TP_PERCENT || "0", 10);
    const paySafePercent = parseInt(process.env.REACT_APP_PAYSAFE_PERCENT || "0", 10);

    const providers = [
        { id: 0, percent: tpPercent },
        { id: 3, percent: paySafePercent },
    ];

    const [provider] = useState(() => {
        try {
            const localData = localStorage.getItem("pp");
            console.log(localData)
            if (localData !== null) {
                return JSON.parse(localData);
            }

            const idx100 = providers.findIndex((p) => p.percent === 100);
            if (idx100 !== -1) {
                return providers[idx100].id;
            }

            const totalPercent = providers.reduce((sum, p) => sum + p.percent, 0) || 1;
            const randomNumber = Math.random() * totalPercent;

            let cumulative = 0;
            for (let i = 0; i < providers.length; i++) {
                cumulative += providers[i].percent;
                if (randomNumber < cumulative) {
                    return providers[i].id;
                }
            }
            return providers[providers.length - 1].id;
        } catch (e) {
            return 0;
        }
    });

    useEffect(() => {
        localStorage.setItem("pp", JSON.stringify(provider));
    }, [provider]);

    return (
        <PaymentContext.Provider value={{ provider }}>
            {children}
        </PaymentContext.Provider>
    );
};

export default PaymentContextProvider;
